export default __webpack_public_path__ + "static/media/art-slt-banner-1.452ba802.jpg";